<mat-toolbar>
  <mat-toolbar-row *ngIf="device.isMobile()" style="justify-content: center;">
    <a mat-button href="https://rjproductionsut.com">about</a>
  </mat-toolbar-row>
  <mat-toolbar-row>
    <a mat-icon-button href="https://rjproductionsut.com" style=" margin-right: 16px">
      <svg style="height: 32px; opacity: 0.3;" xmlns="http://www.w3.org/2000/svg" viewBox="382.3 410 463.06 367.69000000000005">
        <path d="M747.1,767.5a10.08,10.08,0,0,0-2.86-7h0l-39.71-39.71h0l-.21-.21h0a17.39,17.39,0,0,1-4.91-12.11V434.72A24.69,24.69,0,0,0,674.72,410H565.12a24.6,24.6,0,0,0-17.25,7h0l-.16.16-.08.08-158,158h0a24.6,24.6,0,0,0-7.33,17.54c0,.18,0,.36,0,.54h0V752.9s0,0,0,0a24.68,24.68,0,0,0,24.58,24.68H737.21a10.11,10.11,0,0,0,9.89-10.11M626.37,679.9a24.69,24.69,0,0,1-24.69,24.69H480.08A24.69,24.69,0,0,1,455.4,679.9V623.05a24.6,24.6,0,0,1,7.6-17.79h0l115-115h0a24.6,24.6,0,0,1,17.38-7.16h6.31a24.69,24.69,0,0,1,24.69,24.69Z
      M845.31,728.32A24.65,24.65,0,0,0,821.7,704.7v-.05H797a24.67,24.67,0,0,0-24.64,23.67h-.05V754h.05A24.67,24.67,0,0,0,797,777.69h23.67A24.69,24.69,0,0,0,845.36,753V728.32Z" fill="#ffff"/>
      </svg>
    </a>
    <div class="copy" *ngIf="device.isMobile() == false">
      &copy;{{today | date: 'yyyy'}} RJ Productions
    </div>
    <div *ngIf="device.isMobile() == false" class="nav">
      <a mat-button href="https://rjproductionsut.com">about</a>
    </div>
    <a class="hash" routerLink="debug">{{hash}}</a>
    <div class="creation">
      <!-- <span style="opacity: 0.3;">{{ getReferrer() }}</span> -->
      <a mat-icon-button href="https://rjproductionsut.com">
        <img src="https://jaxonwright.com/assets/img/branding/white.png">
      </a>
    </div>
  </mat-toolbar-row>
</mat-toolbar>